module.exports = __webpack_public_path__ + "img/b_Anevil_3.a79997f6.jpeg";